import React, { useState } from "react";
import ChoisirCreneauxRdv from "../app/newcalendar/ChoisirCreneauxRdv";
import { API_BASE } from "../config";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const Badge = ({ children, variant }) => {
  const classes =
    variant === "orange"
      ? "inline-flex items-center rounded-md bg-orange-100 px-2 py-1 text-xs font-bold text-orange-800"
      : variant === "green"
      ? "inline-flex items-center rounded-md bg-emerald-100 px-2 py-1 text-xs font-bold text-emerald-800"
      : "inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-bold text-slate-800";

  return <span className={classes}>{children}</span>;
};

const TypeReunionLabel = ({ value }) => {
  if (value === "A l'étude") return <>A l'étude</>;
  if (value === "Téléphone") return <>Par téléphone</>;
  if (value === "Visio") return <>En visio</>;
  return <></>;
};

const Dispos = ({ rdv }) => {
  const f = rdv?.fields ?? {};
  const dispos = [f.dispo_notaire_1, f.dispo_notaire_2, f.dispo_notaire_3].filter(Boolean);

  if (dispos.length === 0) return null;

  return (
    <ul className="flex flex-row gap-1">
      {dispos.map((d, i) => (
        <li key={i} className="bg-gray-100 text-gray-900 font-bold text-center p-2 rounded-md text-sm">
          {d}
        </li>
      ))}
    </ul>
  );
};

const ConfirmCancelModal = function (props) {
  const { open, onClose, onConfirm, isLoading } = props;

  return (
    <Dialog open={open} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in dark:bg-gray-900/50"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10"
          >
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10 dark:bg-red-500/10">
                <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600 dark:text-red-400" />
              </div>
              <div className="text-left sm:mt-0 sm:ml-4 sm:text-left">
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-white">
                  Supprimer la proposition de créneaux
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    Êtes-vous sûr de vouloir supprimer ces propositions ?
                    Le rendez-vous repassera à <b>“à programmer”</b>.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-3 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                onClick={onConfirm}
                disabled={isLoading}
                className={
                  isLoading
                    ? "mb-0 inline-flex w-full justify-center rounded-md bg-red-600/60 px-3 py-2 text-sm font-semibold text-white shadow-xs sm:ml-3 sm:w-auto cursor-not-allowed"
                    : "mb-0 inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:ml-3 sm:w-auto dark:bg-red-500 dark:shadow-none dark:hover:bg-red-400"
                }
              >
                {isLoading ? "Suppression..." : "Oui, supprimer"}
              </button>

              <button
                type="button"
                data-autofocus
                onClick={onClose}
                disabled={isLoading}
                className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20"
              >
                Non, annuler
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

const RdvBlock = ({ title, rdv, type, idAffaire, notaireAirtableId, refreshData }) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);

  console.log("RdvBlock render", { title, rdv, type, idAffaire, notaireAirtableId });

  if (!rdv) return null;

  const statut = rdv.fields?.statut;
  const typeReunion = rdv.fields?.type_reunion;

  const doCancel = async function () {
    if (!rdv?.id) return;

    setIsCancelling(true);
    try {
        //http://localhost:5050/api/cancel-meeting-proposal
        //https://cloterenotaire.onrender.com/api/cancel-meeting-proposal
      const res = await fetch(`${API_BASE}/api/cancel-meeting-proposal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_rdv: rdv.id }),
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`HTTP ${res.status} - ${txt}`);
      }

      setOpenConfirm(false);

      // ✅ 1) refresh parent data (re-fetch)
      if (typeof refreshData === "function") {
        await refreshData();
      } else {
        console.warn("refreshData non fourni: impossible de rafraîchir l'affichage sans reload.");
      }
    } catch (e) {
      console.error("cancel-meeting-proposal error", e);
      alert("Impossible d'annuler la proposition. Réessaie.");
    } finally {
      setIsCancelling(false);
    }
  };

  const showCancelCTA = statut === "en cours de prog";

  if (statut === "en cours de prog") {
    const dateProp = rdv.fields?.date_proposition
      ? new Date(rdv.fields.date_proposition).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;

    return (
      <>
        <div className="mt-2 bg-white rounded-lg p-4 flex flex-col sm:flex-row gap-2 items-center justify-between">
          <div className="flex flex-row">
            <CalendarDateRangeIcon className="size-12 text-gray-400" />
            <div className="flex flex-col ml-2">
              <h5 className="font-bold text-gray-900">{title}</h5>
              <p className="m-0">
            <span className="inline-block size-2 rounded-full bg-orange-600 !text-orange-600 mr-2"></span>
            En cours de programmation
          </p>
              {dateProp && (
                <p>
                  <small>Créneaux proposés le : {dateProp} / <TypeReunionLabel value={typeReunion} /></small>
                </p>
              )}
              
              
            </div>
          </div>

          <div className="flex flex-col justify-end">
            <Dispos rdv={rdv} />
            {showCancelCTA ? (
            <>
              <button
                type="button"
                onClick={() => setOpenConfirm(true)}
                className="underline text-sm font-semibold text-red-800     flex justify-end"
              >
                Annuler la proposition
              </button>
            </>
          ) : null}
          </div>

          
        </div>
        

        <ConfirmCancelModal
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          onConfirm={doCancel}
          isLoading={isCancelling}
        />
      </>
    );
  }

  if (statut === "programme") {
    return (
      <div className="mt-2 bg-white rounded-lg p-4 flex flex-col sm:flex-row justify-between items-center gap-4">
        <CalendarDateRangeIcon className="size-12 text-gray-400" />
        <div className="flex-1">
          <h5 className="truncate text-lg font-semibold text-gray-700">{title}</h5>
          <p className="m-0">
            <span className="inline-block size-2 rounded-full bg-green-400 mr-2"></span>
            Rendez-vous validé
          </p>
        </div>

        <div>
          <ul className="flex flex-row gap-1">
        <li className="bg-gray-100 text-gray-900 font-bold text-center p-2 rounded-md text-sm">
          {rdv?.fields?.date_finale &&
          (() => {
            const d = new Date(rdv.fields.date_finale);

            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();

            const hh = String(d.getHours()).padStart(2, "0");
            const min = String(d.getMinutes()).padStart(2, "0");

            return `${dd}/${mm}/${yyyy} à ${hh}h${min}`;
          })()
          }
          {" - "}
         {typeReunion ? <TypeReunionLabel value={typeReunion} /> : "Type de réunion non renseigné"}   
        
        </li>
    </ul>
        </div>

        
      </div>
    );
  }

  if (statut === "a programmer") {
    return (
      <div className="mt-2 bg-white rounded-lg p-4 flex flex-col sm:flex-row justify-between items-center gap-4">
        <CalendarDateRangeIcon className="size-12 text-gray-400" />
        <div className="flex-1">
          <h5 className="truncate text-lg font-semibold text-gray-700">{title}</h5>
          <p className="m-0">
            <span className="inline-block size-2 rounded-full bg-slate-400 mr-2"></span>
            Disponibilités à proposer par le notaire
          </p>
        </div>
        <div>
          <ChoisirCreneauxRdv
            where="header"
            id_transaction={idAffaire}
            type={type}
            id_rdv={rdv.id}
            notaireAirtableId={notaireAirtableId}
            refreshData={refreshData}
          />
        </div>
      </div>
    );
  }

  return null;
};

const RdvAffaireImmo = ({
  idAffaire,
  type,
  notaireAirtableId,
  rdvNotaire,
  rdvCompromis,
  rdvActe,
  refreshData,
}) => {
  return (
    <>
      <RdvBlock
        title="Rendez-vous notaire"
        rdv={rdvNotaire}
        type={type}
        idAffaire={idAffaire}
        notaireAirtableId={notaireAirtableId}
        refreshData={refreshData}
      />
      <RdvBlock
        title="Signature - Compromis de vente"
        rdv={rdvCompromis}
        type={type}
        idAffaire={idAffaire}
        notaireAirtableId={notaireAirtableId}
        refreshData={refreshData}
      />
      <RdvBlock
        title="Signature - Acte authentique de vente"
        rdv={rdvActe}
        type={type}
        idAffaire={idAffaire}
        notaireAirtableId={notaireAirtableId}
        refreshData={refreshData}
      />
    </>
  );
};

export default RdvAffaireImmo;